import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const inputCls =
  "w-full bg-white border border-border px-4 py-3 font-body text-navy rounded-none focus:outline-none focus:ring-2 focus:ring-brand-orange focus:border-brand-orange transition-shadow";
const labelCls = "block font-mono uppercase text-[11px] tracking-[0.15em] text-navy-soft mb-2";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-navy grid place-items-center px-5 pt-20">
      <div className="w-full max-w-md">
        <div className="bg-white p-10 border border-border">
          <div className="flex items-center gap-2 mb-8">
            <span className="h-9 w-9 bg-brand-orange grid place-items-center">
              <Lock size={18} className="text-white" />
            </span>
            <span className="font-display font-black text-xl text-navy">Admin Login</span>
          </div>
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <label className={labelCls}>Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="admin@sourcexglobal.com" />
            </div>
            <div>
              <label className={labelCls}>Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
            </div>
            {err && <p data-testid="login-error" className="text-destructive text-sm font-mono">{err}</p>}
            <button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-brand-orange text-white px-8 py-4 font-mono uppercase text-[11px] tracking-[0.2em] hover:bg-brand-orangeHover transition-colors disabled:opacity-60">
              {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in</> : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
